export const RTL_LANGS = ['ar', 'he', 'fa', 'ur'];

export function isRtl(lang) {
  return RTL_LANGS.includes((lang || 'en').toLowerCase());
}

export function dirFor(lang) {
  return isRtl(lang) ? 'rtl' : 'ltr';
}